import React, { useCallback, useEffect, useState } from 'react'
import { useHistory, useParams, Link  } from 'react-router-dom'
import WizardHeader from 'components/VirtualPortal/components/WizardHeader'
import VirtualPortalPreregistrationClosed from 'components/VirtualPortal/components/PreRegistration'
import GenericPopUpModal from 'components/VirtualPortal/components/PopUpModal'
import 'components/VirtualPortal/css/sessions.scss'
import _ from 'lodash'
import DOMPurify from 'dompurify'

const Profile = ({ peerToPeerWizardIsAvailable, flashMessage }) => {
  window.callbackUrl = new URL(location.href).searchParams.get('callback')
  let currentUser = window.currentUser
  const history = useHistory()
  const params = useParams()
  const { wizard, token } = params
  const { currentEvent, LiveChatWidget } = window
  const [ user, setUser ] = useState({})
  const [ isError, setIsError ] = useState(false)
  const [ saving, setSaving] = useState(false)

  // sanitized for Snyk XSS protection
  const cleanEmailMessage = DOMPurify.sanitize('mailto: ' + currentEvent.location_staff_user_email + '?subject=MyEvanta Profile email address update requested&body=Hi,%0D I would like to request that my MyEvanta Profile email address be updated from ' + currentUser.email + ' to the updated email of YOUR NEW EMAIL HERE.%0D Thank You')
  const cleanPhoto = DOMPurify.sanitize(currentUser.photo)

  useEffect(() => {
    setUser({...currentUser})
  },[currentUser])

  const handleUpdate = useCallback((e, fieldType) => {
    e.preventDefault()
    setUser({ ...user, [fieldType]: e.target.value })
  },[user])

  const submit = useCallback(() => {
    setSaving(true)
    if(!user.first_name || !user.last_name){
      setIsError(true)
    }
    window.api.put('/virtual_portal/profile/', {user: user},  ).then(() => {
      let usersFromLocalStorage = JSON.parse(localStorage.getItem('users'))
      if(usersFromLocalStorage) {
        let localUser = _.find(usersFromLocalStorage.event_users, {user_id: parseInt(currentUser.id, 10)})
        // if returns a local user then update localStorage
        if (localUser) {
          localUser.first_name = user.first_name
          localUser.last_name = user.last_name
          localUser.title = user.title
          localUser.organization_name = user.organization_name
          localUser.bio = user.bio
          localStorage.setItem('users', JSON.stringify(usersFromLocalStorage))
        }
      }
      if(params.wizard) {
        history.push('/' + token + '/wishlist/' + params.wizard)
      } else {
        flashMessage({level: 'success', message: 'Your changes have been saved.'})
        history.push('/' + token)
      }
      window.currentUser = {...currentUser, ...user}
    }).catch(() => {
      setSaving(false)
    })
  },[user, token, currentUser, history])

  if(!peerToPeerWizardIsAvailable) {
    return(<VirtualPortalPreregistrationClosed
      currentEvent={currentEvent}
      isVirtualEvent={currentEvent.is_virtual_event}/>)
  }

  if(LiveChatWidget) {
    if(wizard) {
      LiveChatWidget.call('hide')
    } else {
      LiveChatWidget.call('minimize')
    }
  }

  return(
    <div className='wizard-form'>
      <WizardHeader wizard={wizard} activeTab={'Profile'} />
      <div className="container">
        <h3>Update your profile details globally</h3>
        <p>Please update your profile here and add a short biography. Your profile will be visible to peers and participants in the summit. This will update your profile across all community events.</p>
        <p>
          <label>Profile Photo:</label>
          <img width='100' height='100' className="rounded-circle" src={cleanPhoto} alt='' />
          <Link to={'/' + token + '/profile/edit_photo/' + wizard }>
              Edit Profile Photo
          </Link>
        </p>
        <p>
          <label>Corporate Email Address:</label>
          <input
            disabled={ true }
            value={ user.email || '' }
          />
          <label className='red'>
              This field cannot be changed. To update, please send an email to <a href={cleanEmailMessage}>{currentEvent.location_staff_user_email}</a>
          </label>
        </p>

        <p>
          <label className='required'>First Name: <span className='red'>*</span></label>
          <input
            onChange={ (e) => handleUpdate(e, 'first_name') }
            value={ user.first_name || '' }
          />
        </p>

        <p>
          <label>Last Name: <span className='red'>*</span></label>
          <input
            onChange={(e) => handleUpdate(e, 'last_name') }
            value={ user.last_name || '' }
          />
        </p>

        <p>
          <label>Title:</label>
          <input
            onChange={ (e) => handleUpdate(e, 'title') }
            value={ user.title || '' }
          />
        </p>

        <p>
          <label>Organization:</label>
          <input
            onChange={ (e) => handleUpdate(e, 'organization_name') }
            value={ user.organization_name || '' }
          />
        </p>
        <p>
          <label>Biography:</label>
          <textarea
            onChange={(e) => handleUpdate(e, 'bio') }
            value={ user.bio || ''}
          />
        </p>
        <div className='bottom-buttons'>
          <Link to={'/' + token }
            className={ wizard ? 'hide' : ''}
          >
            CANCEL CHANGES
          </Link>
          <button
            disabled={saving}
            onClick={ submit }
            className={'submit btn btn-primary margin-top-10'}>
            {saving ? (<i className="fa fa-refresh fa-spin"></i>) : ''}
            { wizard ? 'SAVE & CONTINUE' : 'SAVE'}
          </button>
        </div>
        { isError &&
          <GenericPopUpModal
            customClass={'wishlist-user-info'}
            status='Error'
            handleCloseGenericModal={() => setIsError(false)}
            content={'<h3>Error</h3><p>First Name and Last Name are required.</p>'} >
          </GenericPopUpModal>}
      </div>

    </div>
  )
}

export default Profile